import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slides, setSlides] = useState([
    {
      title: 'CAE Analysis & Simulation',
      subtitle: 'Finite Element Analysis (FEA), crash simulation, thermal-fluid analysis, and virtual prototyping to optimize designs before production',
      image: ''
    },
    {
      title: 'Mechanical Design Outsourcing',
      subtitle: 'End-to-end CAD/CAM services with 10+ years experience from Japanese automotive industry using CREO, NX, and SolidWorks',
      image: ''
    },
    {
      title: 'Vietnam Manufacturing Sourcing',
      subtitle: '3-axis & 5-axis CNC, sheet metal, injection molding with Japanese quality standards and up to 40% cost reduction',
      image: ''
    }
  ]);

  useEffect(() => {
    fetchBanner();
  }, []);

  const fetchBanner = async () => {
    try {
      const res = await fetch('/api/content/banner');
      const data = await res.json();
      if (data && Array.isArray(data) && data.length > 0) {
        setSlides(data);
      }
    } catch (err) {
      console.error('Error fetching banner:', err);
    }
  };

  // Auto slide every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const current = slides[currentSlide] || slides[0];

  return (
    <section className="relative min-h-[600px] overflow-hidden" style={{ backgroundColor: '#EC4899' }}>
      <div className="absolute inset-0 bg-black/20"></div>

      {/* Container giống phần Resources */}
      <div className="relative z-10 container mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Text Content */}
          <div className="text-white">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              {current.title}
            </h1>
            <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-xl">
              {current.subtitle}
            </p>
            
            <div className="flex flex-wrap gap-4">
              <Link 
                to="/contact"
                className="inline-flex items-center gap-2 bg-white text-pink-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all"
              >
                Contact Us
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
            </div>
          </div>

          {/* Right - Hero Image */}
          <div className="hidden lg:block relative h-[450px] w-full overflow-hidden rounded-2xl">
            <img 
              src={current.image || '/default-hero.jpg'} 
              alt="" 
              className="w-full h-full object-cover" 
            />
          </div>
        </div>

        {/* Dots Navigation */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`h-3 rounded-full transition-all ${
                currentSlide === index 
                  ? 'bg-white w-8' 
                  : 'bg-white/50 hover:bg-white/70 w-3'
              }`}
            />
          ))}
        </div>
      </div>

      {/* Bottom Gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
};

export default Hero;
